// extracted by mini-css-extract-plugin
module.exports = {"blockHeader":"BlockHeader_blockHeader__fVsvL","title":"BlockHeader_title__36noa","button":"BlockHeader_button__FPL1a"};